export default {
  permissions: ['BasicInformationMenu/Permissions/RolesMenu/'],// ['PermissionsDefinitionMenu', 'AssignPermissionsMenu'],
  priority: 7,
  name: app.translate('routes.home.basic.permission.Personnel Roles'),
  icon: 'clipboard-account',
  drawer: true,
};
